
import { Link } from 'react-router-dom';

export default function PepVerse() {
  const features = [
    {
      icon: 'ri-store-3-fill',
      title: 'Virtual Marketplace',
      description: 'Buy, sell, and trade digital assets in the metaverse',
      gradient: 'from-pink-500 to-rose-600',
      link: '/trading'
    },
    {
      icon: 'ri-gamepad-fill',
      title: 'Play & Earn',
      description: 'Engage in games and earn PepCoin rewards',
      gradient: 'from-orange-500 to-red-600',
      link: '/mining'
    },
    {
      icon: 'ri-building-4-fill',
      title: 'Virtual Real Estate',
      description: 'Own and develop properties in PepVerse',
      gradient: 'from-blue-500 to-cyan-600',
      link: '/pepverse'
    },
    {
      icon: 'ri-palette-fill',
      title: 'NFT Gallery',
      description: 'Showcase and trade your unique digital art',
      gradient: 'from-purple-500 to-pink-600',
      link: '/trading'
    },
    {
      icon: 'ri-team-fill',
      title: 'Social Trading',
      description: 'Meet traders, share strategies, and collaborate',
      gradient: 'from-indigo-500 to-purple-600',
      link: '/trading'
    },
    {
      icon: 'ri-trophy-fill',
      title: 'Tournaments',
      description: 'Compete in events and win exclusive rewards',
      gradient: 'from-yellow-500 to-orange-600',
      link: '/pepverse'
    },
  ];

  return (
    <section className="relative py-32 bg-gradient-to-b from-black via-indigo-950/20 to-black overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-pink-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full mb-6">
            <i className="ri-global-line text-purple-400"></i>
            <span className="text-purple-400 text-sm font-semibold">Metaverse Experience</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-white">
            Welcome to PepVerse
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Step into a revolutionary virtual world where crypto meets creativity
          </p>
        </div>

        {/* Main Feature Card */}
        <div className="relative mb-16 rounded-3xl overflow-hidden group">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur-xl"></div>
          <img
            src="https://public.readdy.ai/ai/img_res/ad9bacc74d99d7b38fc7e3720b800bb7.jpg"
            alt="PepVerse"
            className="w-full h-[500px] object-cover object-top opacity-80 group-hover:opacity-100 transition-opacity duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-12">
            <h3 className="text-4xl font-black text-white mb-4">
              Explore Infinite Possibilities
            </h3>
            <p className="text-xl text-gray-300 mb-6 max-w-2xl">
              Immerse yourself in a decentralized virtual universe powered by blockchain technology
            </p>
            <Link
              to="/pepverse"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl font-bold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-rocket-2-line text-xl"></i>
              Enter PepVerse
            </Link>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.link}
              className="group relative bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:border-purple-500/50 transition-all duration-500 hover:scale-105 cursor-pointer overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
              
              <div className="relative z-10">
                <div className={`w-16 h-16 flex items-center justify-center mb-6 bg-gradient-to-br ${feature.gradient} rounded-2xl shadow-lg group-hover:scale-110 transition-all duration-300`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-purple-400 transition-colors duration-300">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg mb-6">
            Ready to start your journey in the metaverse?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/pepverse"
              className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl font-bold text-white hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line mr-2"></i>
              Explore Now
            </Link>
            <Link
              to="/whitepaper"
              className="px-8 py-4 bg-white/5 border border-white/20 rounded-xl font-bold text-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
